import { render, staticRenderFns } from "./personalProductPicker.vue?vue&type=template&id=2d83410c&scoped=true"
import script from "./personalProductPicker.vue?vue&type=script&lang=js"
export * from "./personalProductPicker.vue?vue&type=script&lang=js"
import style0 from "./personalProductPicker.vue?vue&type=style&index=0&id=2d83410c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83410c",
  null
  
)

export default component.exports